import React, { useEffect, useRef } from 'react'

import { Spinner } from '@web/walter-ui-kit'
import { GetCard } from '@web/walter-lib/api'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from '@ant-design/react-slick'
import cn from 'classnames'
import Balance from '../Balance'
import s from './s.module.css'

const sliderSettings = {
    dots: false,
    infinite: false,
    centerMode: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
}

interface Props {
    cards?: GetCard[]
    isCardsLoading?: boolean
    selectedCard?: GetCard
    setSelectedCard: (selectedCard: GetCard) => void
}

function SliderList({ cards, isCardsLoading, selectedCard, setSelectedCard }: Props) {
    const sliderRef = useRef<Slider | null>(null)

    useEffect(() => {
        if (sliderRef.current) {
            const cardIndex = cards?.findIndex(card => card.id === selectedCard?.id)

            if (cardIndex != null) {
                sliderRef.current.slickGoTo(cardIndex)
            }
        }
    }, [cards, selectedCard?.id])

    if (isCardsLoading) {
        return (
            <div className={s.spinner}>
                <Spinner intent="accent" size={36} />
            </div>
        )
    }

    if (!cards) {
        return null
    }

    return (
        <>
            {cards.length <= 1 ? (
                <div className={s.singleProductContent}>
                    {cards.map((card, i) => (
                        <div key={card.id + i} className={s.mobileCard}>
                            <Balance card={card} isCurrent={selectedCard?.id === card.id} />
                        </div>
                    ))}
                </div>
            ) : (
                <div className={s.slider}>
                    <Slider
                        {...sliderSettings}
                        beforeChange={(_, next) => {
                            cards?.[next] && setSelectedCard(cards?.[next])
                        }}
                        ref={sliderRef}
                    >
                        {cards?.map((card, i) => (
                            <div
                                key={card.id + i}
                                className={cn(s.mobileCard, selectedCard?.id !== card.id && s.opacity)}
                                onClick={() => sliderRef.current?.slickGoTo(i)}
                            >
                                <Balance card={card} isCurrent={selectedCard?.id === card.id} />
                            </div>
                        ))}
                    </Slider>
                </div>
            )}
        </>
    )
}

export { SliderList }
